/*****
 * Created with WebStorm.
 * Date : 2018/1/24.
 * Author : Ztr.
 * Func : ..
 ******/
import api from "../../config/api";
export default {
    state: {
        commonData: {},
        menu: [],
        routers: [],
        showBall:true
    },
    mutations: {
        setCommonData: (state, data) => {
            state.commonData = data;
        },
        setShowBall:(state, data) => {
            state.showBall = data;
        }
    },
    actions: {

    }
}



// WEBPACK FOOTER //
// ./src/store/modules/power.js